/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Quote_MidInputs */

const en_dr_why_quote_mid = /** @type {(inputs: Dr_Why_Quote_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. The proof lives in`)
};

const id_dr_why_quote_mid = /** @type {(inputs: Dr_Why_Quote_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Buktinya di`)
};

/**
* | output |
* | --- |
* | ". The proof lives in" |
*
* @param {Dr_Why_Quote_MidInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_quote_mid = /** @type {((inputs?: Dr_Why_Quote_MidInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Quote_MidInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_quote_mid(inputs)
	return en_dr_why_quote_mid(inputs)
});